module.exports = {
  carMenu: () => {
    return {
      "IONIQ 5 EV-POWER": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },

      "TUCSON HEV LIMITED": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },

      "PALISADE SPORT": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },

      "STARIA LUJO": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },

      "VENUE LIMITED AT": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },
      "HB20 ADVANCE": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },
      "HB20S ADVANCE": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },

      "CRETA PREMIUM": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },
      "KONA HEV LIMITED": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },

      "SANTA FE HEV LIMITED 4x4": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_AR.svg"),
            slug: "ar"
          }
        ]
      },

    }
  }
}